/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { Enabled } from './Enabled';
import { FileTreeDirectoryItem } from './FileTreeDirectoryItem';
import { FileTreeFileItem } from './FileTreeFileItem';
const EnabledEditorParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'template',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['file', FileTreeFileItem],
            ['dir', FileTreeDirectoryItem],
        ])),
    ],
]), Enabled);
export class EnabledEditor extends Enabled {
    static decode(input) {
        return EnabledEditorParser.decode(input).map(res => new EnabledEditor(res));
    }
    static unsafeDecode(input) {
        return EnabledEditor.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return EnabledEditorParser.encode(data);
    }
    static schema() {
        return EnabledEditorParser.schema();
    }
}
